import { render, staticRenderFns } from "./SelectArtist.vue?vue&type=template&id=64775d0c"
import script from "./SelectArtist.vue?vue&type=script&lang=js"
export * from "./SelectArtist.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports